import React from 'react';
import { Mail } from 'lucide-react';

/**
 * ProviderIcon — full-colour brand logo for an email source/provider, as an
 * inline SVG (no asset/icon-font dependency). Used by the email-inbox
 * settings and the Inkorg detail view.
 *
 * `provider` is the connection provider or inbox-item source:
 *   'gmail' | 'outlook' → brand logo
 *   'mailgun' (forwarded) | 'upload' | anything else → neutral envelope
 */
const LABELS = {
    gmail: 'Gmail',
    outlook: 'Outlook',
    mailgun: 'E-postvidarebefordran',
    upload: 'Uppladdning',
};

export default function ProviderIcon({ provider, size = 18 }) {
    const label = LABELS[provider] || provider || 'E-post';
    if (provider === 'gmail') {
        return (
            <svg viewBox="0 0 256 193" height={size} width={size * 1.33} role="img" aria-label={label} style={{ flexShrink: 0 }}>
                <title>{label}</title>
                <path fill="#4285f4" d="M58.182 192.05V93.14L27.507 65.077L0 49.504v125.091c0 9.658 7.825 17.455 17.455 17.455z" />
                <path fill="#34a853" d="M197.818 192.05h40.727c9.659 0 17.455-7.826 17.455-17.455V49.505l-31.156 17.837l-27.026 25.798z" />
                <path fill="#ea4335" d="m58.182 93.14l-4.174-38.647l4.174-36.989L128 69.868l69.818-52.364l4.669 34.992l-4.669 40.644L128 145.504z" />
                <path fill="#fbbc04" d="M197.818 17.504V93.14L256 49.504V26.231c0-21.585-24.64-33.89-41.89-20.945z" />
                <path fill="#c5221f" d="m0 49.504l26.759 20.07L58.182 93.14V17.504L41.89 5.286C24.61-7.66 0 4.646 0 26.23z" />
            </svg>
        );
    }
    if (provider === 'outlook') {
        return (
            <svg viewBox="0 0 32 32" height={size} width={size} role="img" aria-label={label} style={{ flexShrink: 0 }}>
                <title>{label}</title>
                <path fill="#0072c6" d="M19.484 7.937v5.477l1.916 1.205a.5.5 0 0 0 .21 0l8.238-5.554a1.174 1.174 0 0 0-.959-1.128Z" />
                <path fill="#0072c6" d="m19.484 15.457l1.747 1.2a.52.52 0 0 0 .543 0c-.3.181 8.073-5.378 8.073-5.378v10.066a1.408 1.408 0 0 1-1.49 1.555h-8.874zm-9.044-2.525a1.61 1.61 0 0 0-1.42.838a4.13 4.13 0 0 0-.526 2.218A4.05 4.05 0 0 0 9.02 18.2a1.6 1.6 0 0 0 2.771.022a4 4 0 0 0 .515-2.2a4.37 4.37 0 0 0-.5-2.281a1.54 1.54 0 0 0-1.366-.809" />
                <path fill="#0072c6" d="M2.153 5.155v21.427L18.453 30V2Zm10.908 14.336a3.23 3.23 0 0 1-2.7 1.361a3.19 3.19 0 0 1-2.64-1.318A5.46 5.46 0 0 1 6.706 16.1a5.87 5.87 0 0 1 1.036-3.616a3.27 3.27 0 0 1 2.744-1.384a3.12 3.12 0 0 1 2.61 1.321a5.64 5.64 0 0 1 1 3.484a5.76 5.76 0 0 1-1.035 3.586" />
            </svg>
        );
    }
    return <Mail size={size} style={{ color: '#9ca3af', flexShrink: 0 }} aria-label={label} />;
}
